import { TemplateRef } from '@angular/core';

export function isTemplate(object: any): boolean {
  return object instanceof TemplateRef;
}
